import {handleActions} from 'redux-actions';

import * as Actions from '../actions';

export default handleActions(
    {
        [Actions.employeeChanged.type]: (state, {payload}) => payload,
    },
    '',
);
